import { useCallback, useContext } from 'react';
import { releaseHintContext } from './release-hint-provider';

export const getReleaseHintReferenceId = (releaseDate, name) => {
  return `release-hint-id-${releaseDate}-${name}`;
};

export const useRegisterReleaseHintReference = () => {
  const { releaseHintReferenceDoms, addReleaseHintReferenceDom } = useContext(releaseHintContext);

  const registerReleaseHintReference = useCallback(
    (releaseDate, name) => {
      return (element) => {
        if (!element) return;

        const id = getReleaseHintReferenceId(releaseDate, name);
        if (releaseHintReferenceDoms[id] !== element) {
          addReleaseHintReferenceDom(id, element);
        }
      };
    },
    [addReleaseHintReferenceDom, releaseHintReferenceDoms]
  );

  return registerReleaseHintReference;
};
